import React from "react";
import "./style.css";

const Success = () => {
  const handleClick = () => {
    const prod = process.env.REACT_APP_NODE_ENV === "production";

    const url = prod
      ? "https://studio.arway.ai/auth/login"
      : "https://dev-studio.arway.ai/auth/login";

    window.location.replace(url);
  };

  return (
    <div className="success-box-container">
      <div className="success-box">
        <h1 className="success-header">Success!</h1>
        <p className="success-body">
          Your email has been verified! Head back to the app or
          download from the app store to get started!</p>
        <div className="success-footer">
          <button className="success-footer-button" onClick={handleClick}>
            Open ARWay Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default Success;
